export const registerMobileNotificationActions = (store: any) => {
}
